import { defineMessages } from 'react-intl';

const messages = defineMessages({
  itemOption: {
    description: 'advancedSearch.orders.filters.itemOption',
    defaultMessage: 'Item Option',
    id: 'SuF+Fj',
  },
});

export default messages;
